import { PATHS } from '@ctcells/core'

import type { GroupTabDef } from '../groupTabs.ts'

/**
 * 「준비」 문의 탭 3종(시료 · 레시피 · 템플릿) — **유일한 출처다.**
 *
 * 🔴 **「템플릿」은 2026-10-13 에 탭으로 올렸다**(eric 「응 그러면. 탭 추가해줘..」). 종전엔 레시피 머리의 [템플릿 관리] 단추로 들어가
 *    레시피 탭이 고른 채 레시피 목록 자리에 템플릿 표가 섰다 — 「같은 레시피 표에 템플릿 줄」처럼 보였다. 주소는 종전 그대로
 *    (`/recipes/templates`)이고, 2026-10-26 부터 «레시피» 템플릿 하나만 선다(eric 「응.. 다 빼줘」 · `TemplatesSplitRoute`).
 *
 * ⚠ **「랩웨어」 탭은 2026-10-11 에 걷었다** — 서버 v0.9.4 가 옛 카탈로그(`/labware-definitions`)를 걷었다(core `1cd3f92a`).
 *   옛 `/labware` 주소는 템플릿 목록으로 리다이렉트된다(템플릿의 `labware` 종류 화면도 2026-10-26 걷었다).
 *
 * 🔴 시료·레시피·랩웨어는 사이드바에 따로 있다가 2026-09-18 eric 지시로 문 하나로 묶였다
 *    ("리소스 카테고리 자원 메뉴에 세개 넣으라고 시료 레시피 랩웨어 말이야").
 *    ⚠ **그룹 이름 「리소스」는 그대로 둔다** — 그 아래 항목이 하나만 남는 모양이 되는데 그게 지시다.
 * 🔴 **그 문의 이름은 2026-09-21 「자원」 → 「준비」로 바뀌었다**(eric: 게임·클라우드 냄새).
 *    바뀐 것은 `ko.ts` 의 값 한 줄이다 — 키·경로·파일명은 `resources` 그대로다.
 *
 * 🔴 **권한이 갈린다**(2026-09-21 정정 — 종전에는 셋 다 `view` 였다). 서버 실물이 그렇다:
 *
 *    | 탭 | 조회 경로 | 서버가 허용하는 역할 | 권한 |
 *    | --- | --- | --- | --- |
 *    | 시료 | `GET /samples` | **operator·admin** (`READ_ROLES = WRITE_ROLES`) | `view` |
 *    | 레시피 | `GET /recipes` | 전원(`require_roles(ROLES)`) | `monitor` |
 *    | 템플릿 | `GET /recipes/standard` | 전원(`recipes_v2.py` `ROLES`) | `monitor` |
 *
 *    시료만 막히는 이유는 **`patient_id` 직접 노출 · PII 접촉면**이다(계약 `listSamples`
 *    `x-required-role` · 정본 `07 §2.4`). ⇒ 문(「준비」)은 가장 약한 `monitor` 이고
 *    **시료 탭만 `view`** 를 건다. 그래야 viewer 가 레시피·랩웨어를 그대로 보고
 *    시료 탭은 **숨겨지지 않고 비활성 + 사유**로 선다(CLAUDE.md RBAC).
 * ⚠ **셋을 다시 `view` 로 되돌리지 마라** — viewer 가 서버는 200 을 주는 두 화면을 잃는다.
 *
 * 탭 전환·잠금·이동 규칙은 관리와 **같은 기계**(`../groupTabs.ts`)를 쓴다. 복붙이 아니다.
 */
export type ResourceTabId = 'samples' | 'recipes' | 'templates'

/** 순서 = 화면 표시 순서. 기본 진입은 첫 번째(`시료`)이고 사이드바 순서 그대로다 */
export const RESOURCE_TABS: readonly GroupTabDef<ResourceTabId>[] = [
  { id: 'samples', path: PATHS.samples, labelKey: 'nav.item.samples', permission: 'view' },
  { id: 'recipes', path: PATHS.recipes, labelKey: 'nav.item.recipes', permission: 'monitor' },
  { id: 'templates', path: PATHS.templates, labelKey: 'nav.item.templates', permission: 'monitor' },
]
